import {UI, type PartialOptions} from "../../../../../../stem-core/ui/UIBase";

import {UserAddress} from "../../../../../../client/state/UserAddressStore";
import {PlusIcon} from "../../../../../../core/ui/SVGElements.jsx";
import {styleRule} from "../../../../../../stem-core/decorators/Style";
import {registerStyle} from "../../../../../../stem-core/ui/style/Theme";
import {NOOP_FUNCTION} from "../../../../../../stem-core/base/Utils";
import {StyleSheet} from "../../../../../../stem-core/ui/Style";
import {iFrameUserDataService} from "../../../../../services/IFrameUserDataService";
import {MakeMerchantUserResourcesAccessLink} from "../../../../../common/MerchantUserResourcesAccessLink";
import {RadioListInput} from "../../../../../../core/ui/input/radio/RadioListInput.jsx";
import {LinkButton} from "../../../../../../core/ui/LinkButton.jsx";
import {Messages} from "../../../../../Messages.js";
import {Flow} from "../../../../flows/Flow.js";
import {AddressDescription} from "./AddressDescription.jsx";


class ChooseAddressComponentStyle extends StyleSheet {
    @styleRule
    addNewAddress = {
        color: this.themeProps.LINK_COLOR,
        width: "fit-content",
        cursor: "pointer",
        fontWeight: this.themeProps.FONT_WEIGHT_REGULAR,
        whiteSpace: "nowrap",
        marginTop: "1.55rem",
        display: "inline-block",
        ">*": {
            opacity: 0.8,
            display: "inline-block",
        },
        ":hover>*": {
            opacity: 1,
        },
        " g": {
            fill: this.themeProps.LINK_COLOR,
        },
        ">:last-child": {
            marginLeft: 12,
        },
        ">:first-child": {
            transform: "translateY(1px)",
        },
    };
}


interface ChooseAddressComponentOptions {
    onChange?: (...args: any[]) => void;
}

@registerStyle(ChooseAddressComponentStyle)
export class ChooseAddressComponent extends UI.Element<ChooseAddressComponentOptions> {
    getDefaultOptions(): PartialOptions<ChooseAddressComponent> {
        return {
            ...super.getDefaultOptions(),
            onChange: NOOP_FUNCTION,
        }
    }

    render() {
        const {styleSheet} = this;
        const extraAddressCount = iFrameUserDataService.getExtraUserAddressCount();

        return [
            <RadioListInput
                onChange={(value) => this.handleListItemSelect(value)}
                entries={UserAddress.all()}
                initialValue={Flow.address.selectedValue}
                formatter={(userAddress) => <AddressDescription userAddress={userAddress} />}
            />,
            <LinkButton className={styleSheet.addNewAddress} onClick={() => Flow.address.enterNewValue()}>
                <PlusIcon size={12.25}/>
                <span>{Messages.addNewAddress}</span>
            </LinkButton>,
            MakeMerchantUserResourcesAccessLink(extraAddressCount),
        ];
    }

    isValid() {
        return this.getAddress() != null;
    }

    getAddress() {
        return Flow.address.selectedValue;
    }

    handleListItemSelect(address: UserAddress) {
        Flow.address.update({selectedValue: address});
        this.options.onChange();
    }

    onMount() {
        this.attachListener(Flow.address, () => this.redraw());
    }
}
